// extracted by mini-css-extract-plugin
export default {"container":"CurConversion_container__khAcI","form":"CurConversion_form__MjQeI","input_con":"CurConversion_input_con__9gsMy"};